import { LOGS_ACTIONS } from "../Actions/logsActions";

export const logsReducer = (state = [], action) => {

    switch (action.type) {
        case LOGS_ACTIONS.ADD: {
            const { log } = action.payload;

            return [
                log,
                ...state
            ];
        }
    } 
    return state;
}